import React, { Fragment, createElement } from "react";
import { minutesToHHmm, formatDateTimeToFriendshipDate } from "../../../js/shared/utils";

import Button from "../../../shared/button/button";
import Collapse from "../../../shared/Collapse/Collapse";
import Loading from "../../../shared/Loading/Loading";
import { SCHEDULED } from "../../shared/constants";

const SaleDetailsFlightPanel = ({ item, flightButtonAllow, ...props } = props) => {
	// collapse title const
	const collapseTitle = (
		<span className="font-size-large">
			<strong>{item.totalPassengers}</strong>{" "}
			{item.totalPassengers == 1 ? "Passageiro" : "Passageiros"}{" "}
		</span>
	);

	// collapse content const
	const collapseContent = (
		<ul className="sale-details-flight-panel__passengers--ul">
			{item.passengers.map((val, idx) => {
				return (
					<li key={idx} className="sale-details-flight-panel__passengers--li">
						<div className="sale-details-flight-panel__passengers--li--dot" />
						{val.name}
					</li>
				);
			})}
		</ul>
	);

	return (
		<Fragment>
			<div className="sale-details-flight-panel--header font-weight-bold font-size-normal">
				Detalhes do voo
			</div>

			<div className="sale-details-flight-panel__passengers">
				<Collapse headerIcon="icon-user" headerTitle={collapseTitle} content={collapseContent} />
			</div>

			{item.flights.length > 0 && <hr />}

			{item.flights.map((flight, idx) => {
				return (
					<Fragment key={idx}>
						{idx == 1 && <hr />}
						<ul className="sale-details-flight-panel__flight-info--ul">
							<li className="sale-details-flight-panel__flight-info--li">
								<div className="sale-details-flight-panel__flight-info--li--left">
									<div className="sale-details-flight-panel__flight-info--li--left--departure">
										<div className="sale-details-flight-panel__flight-info--li--left--rounded" />
									</div>
									<div className="sale-details-flight-panel__flight-info--li--left--dotted-line" />
								</div>
								<div className="sale-details-flight-panel__flight-info--li--right m-b-16 font-size-large">
									<div>
										<span>Partida: </span>
										<span className="value">
											{formatDateTimeToFriendshipDate(flight.departureDate)}
										</span>
									</div>
									<small>{flight.airportFrom}</small>
								</div>
							</li>

							<li className="sale-details-flight-panel__flight-info--li">
								<i className="icon-arrow-right offer-icon-arrow font-size-large" />
							</li>

							<li className="sale-details-flight-panel__flight-info--li">
								<div className="sale-details-flight-panel__flight-info--li--left">
									<div className="sale-details-flight-panel__flight-info--li--left--arrival">
										<div className="sale-details-flight-panel__flight-info--li--left--rounded" />
									</div>
								</div>
								<div className="sale-details-flight-panel__flight-info--li--right m-t--6 font-size-large">
									<div>
										<span>Chegada: </span>
										<span className="value">
											{formatDateTimeToFriendshipDate(flight.arrivalDate)}
										</span>
									</div>
									<small>{flight.airportTo}</small>
								</div>
							</li>
						</ul>

						<hr className="sale-details-flight-panel--dotted" />

						<div className="sale-details-flight-panel--resume font-size-medium">
							<div>
								<span>Duração: </span>
								<span className="value">{minutesToHHmm(flight.duration)}</span>
							</div>
							<div>
								<span> CIA: </span>
								<span className="value">{flight.airline}</span>
							</div>
							<div>
								<span>Voo: </span>
								<span className="value">{flight.flight}</span>
							</div>
							<div>
								<span>Classe: </span>
								<span className="value">{flight.class}</span>
							</div>
						</div>
					</Fragment>
				);
			})}

			<div className="sale-details-flight-panel__buttons">
				<Button
					className={!item.allowInconsistency ? "btn-light-gray-md-label" : "btn-secondary-md-label"}
					onClick={() => props.clickInconsistency(true)}
					disabled={!item.allowInconsistency}
					data-action="sale-details-flight-panel-report-divergence"
				>
					<span className="font-weight-normal font-size-normal">Informar divergência</span>
				</Button>
				<Button
					className={flightButtonAllow ? "btn-secondary-md-label" : "btn-light-gray-md-label"}
					disabled={!flightButtonAllow}
					onClick={e => props.flightNotify(e)}
					data-action="sale-details-flight-panel-change"
				>
					<span className="font-weight-normal font-size-normal"> Comunicar alteração no voo</span>
				</Button>
			</div>
			<div className="sale-details-flight-panel__messages">
				{props.salesCanceled && (
					<span className="sale-details-flight-panel__text-canceled mb-16">
						Seu pagamento foi cancelado porque o comprador desistiu da passagem.
					</span>
				)}
				{props.salesResale && props.modality !== SCHEDULED && (
					<span className="sale-details-flight-panel__text-canceled mb-16">
						Você não receberá por esta transação porque este valor foi pago a você numa outra venda,
						da qual o comprador desistiu da passagem.
					</span>
				)}
			</div>
		</Fragment >
	);
};

export default SaleDetailsFlightPanel;
